import { combineReducers } from "redux";
import { auth } from "./authReducer";
import { mode } from "./modeReducer";
import { microphone } from "./micReducer";
import { notifications } from "./notificationReducer";
import { projects } from "./projectReducer";
import { recordings } from "./recordingReducer";
import { comments } from "./commentReducer";
import { AUTH_LOGOUT_SUCCESS } from "../actions/types";

const appReducer = combineReducers({
  auth,
  mode,
  microphone,
  projects,
  recordings,
  comments,
  notifications,
});

const rootReducer = (state, action) => {
  if (action.type === AUTH_LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
